import React from "react";
import PropTypes from "prop-types";
import { VIDEO_TYPE } from "./VideoType";
import { VideoPlayer as BaseVideoPlayer } from "../../sharedComponents/VideoPlayer";
import { CloudinaryVideo } from "./CloudinaryVideo";

const VideoPlayer = ({ type, ...props }) => {
	switch (type.toLowerCase()) {
		case VIDEO_TYPE.CLOUDINARY.toLowerCase():
			return (
				<CloudinaryVideo
					className={props.className}
					style={props.style}
					publicId={props.videoId}
					posterUrl={props.videoPoster}
					autoPlay={props.autoPlay}
					lang={props.lang}
					setVideoPlayer={props.setVideoPlayer}
				/>
			);
		default:
			// eslint-disable-next-line react/jsx-props-no-spreading
			return <BaseVideoPlayer type={type} {...props} />;
	}
};

VideoPlayer.propTypes = {
	type: PropTypes.string,
	className: PropTypes.string,
	style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
	videoId: PropTypes.string.isRequired,
	videoTitle: PropTypes.string,
	videoPoster: PropTypes.string,
	autoPlay: PropTypes.bool,
	lang: PropTypes.string,
	setVideoPlayer: PropTypes.func,
	customImplementation: PropTypes.func,
};

VideoPlayer.defaultProps = {
	type: VIDEO_TYPE.YOUTUBE,
	className: undefined,
	style: undefined,
	videoTitle: undefined,
	videoPoster: undefined,
	autoPlay: false,
	lang: "en",
	setVideoPlayer: () => {},
	customImplementation: () => {},
};

export { VideoPlayer, VIDEO_TYPE };
